module.exports = __webpack_public_path__ + "static/media/1_A1_08.567f7e03.png";